import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_SPECIAL_ORDER_PRODUCT_TAG } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { SpecialOrderProductTag as SpecialOrderProductTagUnified } from './SpecialOrderProductTag'
import { SpecialOrderProductTagLegacy } from './SpecialOrderProductTagLegacy'

type Props = {
  className?: string
}

export const SpecialOrderProductTag: React.FC<Props> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_SPECIAL_ORDER_PRODUCT_TAG
  )

  return isUnifiedEnabled ? (
    <SpecialOrderProductTagUnified {...props} />
  ) : (
    <SpecialOrderProductTagLegacy {...props} />
  )
}
